package signSymptom.containers


import com.jingfangpai.api.clients.SignSymptomApiClient
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.data.response.ApiResponse
import com.jingfangpai.common.orm.mapping.SignSymptom
import com.jingfangpai.signSymptom.model.SignSymptomDetail
import com.jingfangpai.signSymptom.model.SignSymptomNames
import com.jingfangpai.signSymptom.model.SignSymptomRelationDto
import react.*
import react.dom.div
import setTitle
import signSymptom.components.SignSymptomEdit

external interface SignSymptomEditPageProps : RProps {
   var id:String
}

data class SignSymptomEditPageContextData(
    var getNames: (okcallback:(ApiResponse<SignSymptomNames>)->Unit, errorCallback:(Throwable)->Unit) -> Unit,
    var getOptions: (okcallback:(ApiResponse<Array<CascadedOption<String>>>)->Unit, errorCallback:(Throwable)->Unit) -> Unit,
    var getDetail:(id:String, okCallback: (result:ApiResponse<SignSymptomDetail>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var save:(signSymptom:com.jingfangpai.common.orm.mapping.SignSymptom, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<SignSymptom>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveCharacteristic:(signSymptomCharacteristic:com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getCharacteristics:(signSymptomId:kotlin.String, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.common.orm.mapping.SignSymptomCharacteristic>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var saveSignSymptomRelation:(relation:com.jingfangpai.common.orm.mapping.SignSymptomRelation, okCallback: (result: ApiResponse<SignSymptomRelationDto>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit,
    var getSignSymptomRelations:(signSymptomId:kotlin.String, type:com.jingfangpai.common.orm.mapping.enums.SignSymptomRelationType?,okCallback: (result: ApiResponse<List<SignSymptomRelationDto>>) -> Unit, errorCallback: (exception:Throwable) -> Unit)->Unit
)

val SignSymptomEditPageContext = createContext(SignSymptomEditPageContextData(SignSymptomApiClient::getNames,SignSymptomApiClient::getOptions,SignSymptomApiClient::getDetail,SignSymptomApiClient::save,SignSymptomApiClient::saveCharacteristic,SignSymptomApiClient::getCharacteristics,SignSymptomApiClient::saveSignSymptomRelation,SignSymptomApiClient::getSignSymptomRelations))

val SignSymptomEditPageProvider = functionalComponent<SignSymptomEditPageProps> { props ->

    setTitle("体征症状编辑")

    useEffectOnce { }

    SignSymptomEditPageContext.Provider(SignSymptomEditPageContextData(SignSymptomApiClient::getNames,SignSymptomApiClient::getOptions,SignSymptomApiClient::getDetail,SignSymptomApiClient::save,SignSymptomApiClient::saveCharacteristic,SignSymptomApiClient::getCharacteristics,SignSymptomApiClient::saveSignSymptomRelation,SignSymptomApiClient::getSignSymptomRelations)) {
        div("SignSymptomEditPage-page") {
            child(SignSymptomEdit) {
                attrs{
                    id = props.id
                }
            }
        }
    }
}
